import React, {useEffect} from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './Utils/i18n';

import AppRoutes from './appRoutes';

import store from './redux/store';

import ThemeProvider from './Components/ThemeProvider';
import './main.scss';
import ReactGA from "react-ga4";
// ReactGA.initialize(import.meta.env.VITE_GOOGLE_ANALYTICS);

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
